import { IGeneralInfoOfMember } from '../interfaces/iGeneralInfoOfMember'
import { IOrganization } from "../interfaces/iOrganization";
import { Organization } from "../classes/organization";
import { CurrentStatuses } from '../../components/dashboard/components/mainPanel/components/currentAccountStatus/enums/currentStatuses';
import { IMemberMilestoneMarkerInfo } from '../interfaces/iMember';

export class GeneralInfoOfMember implements IGeneralInfoOfMember {
	public firstName: string;
	public lastName: string;
	public role: string;
	public key: string = "";
	public bio: string = "";
	public name: string = "";
	public quote: string = "";
	public quoteCredit: string = "";
	public imgUrl: string = "";
	public organization: IOrganization = new Organization();
	public matchingStatus: CurrentStatuses = CurrentStatuses.Matching ;
	public pausedUntilDate: Date;
	public isAdmin: number;
	public memberSince: string;
	public pausedDate: string;
	public dischargeDate: string;
	public milestoneMarker: IMemberMilestoneMarkerInfo;

	constructor(generalInfoOfUser: IGeneralInfoOfMember = { key: "" } as IGeneralInfoOfMember) {
		this.firstName = generalInfoOfUser.firstName;
		this.lastName = generalInfoOfUser.lastName;
		this.role = generalInfoOfUser.role;
		this.key = generalInfoOfUser.key;
		this.bio = generalInfoOfUser.bio;
		this.name = generalInfoOfUser.name;
		this.quote = generalInfoOfUser.quote;
		this.quoteCredit = generalInfoOfUser.quoteCredit;
		this.imgUrl = generalInfoOfUser.imgUrl;
		this.organization = generalInfoOfUser.organization;
		this.matchingStatus = generalInfoOfUser.matchingStatus;
		this.pausedUntilDate = generalInfoOfUser.pausedUntilDate;
		this.isAdmin = generalInfoOfUser.isAdmin;
		this.memberSince = generalInfoOfUser.memberSince;
		this.pausedDate = generalInfoOfUser.pausedDate;
		this.dischargeDate = generalInfoOfUser.dischargeDate;
		this.milestoneMarker = generalInfoOfUser.milestoneMarker;
	}
	
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/generalInfoOfMember.ts